export default __webpack_public_path__ + "static/media/trailers.d420e0dc.png";